import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allTrainingReport: [],
    pdfRows: [],
    loading: false,
    error: null,
};

const trainingReportSlice = createSlice({
    name: 'trainingReport',
    initialState,
    reducers: {
        setAllTrainingReport: (state, action) => {
            state.allTrainingReport = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setPdfRows: (state, action) => {
            state.pdfRows = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllTrainingReport } = trainingReportSlice.actions;

export default trainingReportSlice.reducer;